import(/* webpackMode: "eager" */ "/app/src/components/breadcrumbs/breadcrumbs.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/portfolio/portfolio.tsx")